import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function Career() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content contactpage">
                        <h2>GALLERY</h2>
                        <div class="row">
                          <div class="col-sm-3">
                            <a class="fancybox" href="images/idpl-gallery1.jpg" data-fancybox-group="gallery" title=""> <img src="images/thumb/1.jpg" alt="" class="img-responsive" /></a>
                          </div>

                          <div class="col-sm-3">
                            <a class="fancybox" href="images/idpl-gallery2.jpg" data-fancybox-group="gallery" title=""> <img src="images/thumb/2.jpg" alt="" class="img-responsive" /></a>
                          </div>

                          <div class="col-sm-3">
                            <a class="fancybox" href="images/idpl-gallery3.jpg" data-fancybox-group="gallery" title=""> <img src="images/thumb/3.jpg" alt="" class="img-responsive" /></a>
                          </div>

                          <div class="col-sm-3">
                            <a class="fancybox" href="images/idpl-gallery4.jpg" data-fancybox-group="gallery" title=""> <img src="images/thumb/4.jpg" alt="" class="img-responsive" /></a>
                          </div>

                          <div class="col-sm-3">
                            <a class="fancybox" href="images/idpl-gallery5.jpg" data-fancybox-group="gallery" title=""> <img src="images/thumb/5.jpg" alt="" class="img-responsive" /></a>
                          </div>

                          <div class="col-sm-3">
                            <a class="fancybox" href="images/idpl-gallery6.jpg" data-fancybox-group="gallery" title=""> <img src="images/thumb/6.jpg" alt="" class="img-responsive" /></a>
                          </div>

                          <div class="col-sm-3">
                            <a class="fancybox" href="images/idpl-gallery7.jpg" data-fancybox-group="gallery" title=""> <img src="images/thumb/7.jpg" alt="" class="img-responsive" /></a>
                          </div>

                          <div class="col-sm-3">
                            <a class="fancybox" href="images/idpl-gallery8.jpg" data-fancybox-group="gallery" title=""> <img src="images/thumb/8.jpg" alt="" class="img-responsive" /></a>
                          </div>

                          <div class="col-sm-3">
                            <a class="fancybox" href="images/idpl-gallery9.jpg" data-fancybox-group="gallery" title=""> <img src="images/thumb/9.jpg" alt="" class="img-responsive" /></a>
                          </div>

                          <div class="col-sm-3">
                            <a class="fancybox" href="images/idpl-gallery10.jpg" data-fancybox-group="gallery" title=""> <img src="images/thumb/10.jpg" alt="" class="img-responsive" /></a>
                          </div>

                          <div class="col-sm-3">
                            <a class="fancybox" href="images/idpl-gallery11.jpg" data-fancybox-group="gallery" title=""> <img src="images/thumb/11.jpg" alt="" class="img-responsive" /></a>
                          </div>

                          <div class="col-sm-3">
                            <a class="fancybox" href="images/idpl-gallery12.jpg" data-fancybox-group="gallery" title=""> <img src="images/thumb/12.jpg" alt="" class="img-responsive" /></a>
                          </div>

                          <div class="col-sm-3">
                            <a class="fancybox" href="images/idpl-gallery13.jpg" data-fancybox-group="gallery" title=""> <img src="images/thumb/13.jpg" alt="" class="img-responsive" /></a>
                          </div>
                        </div>

                        <div class="clearfix"></div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
